// extracted by mini-css-extract-plugin
export default {"benefit":"Benefit_benefit__Rs7Cp","item":"Benefit_item__qRoMo","title":"Benefit_title__qb-4B","description":"Benefit_description__23xlP"};